import React, { useRef } from "react";
import emailjs from "@emailjs/browser";
import "./InsuranceForm.css";

const InsuranceForm = () => {
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm("service_n4lvwiu", "template_1t5a1of", form.current, "VywvnI8Bg-_K9ccSj")
      .then(
        (result) => {
          alert("Form submitted successfully!");
          form.current.reset();
        },
        (error) => {
          console.error("EmailJS error:", error);
          alert("Something went wrong. Please try again.");
        }
      );
  };

  return (
    <div className="premium-insurance-wrapper">
      <div className="insurance-header">
        <span className="insurance-eyebrow">Instant Quotes</span>
        <h2 className="insurance-title">Get Your Car Insured</h2>
        <p className="insurance-subtitle">Protect your drive with customized premium coverage options.</p>
        <div className="insurance-accent-line"></div>
      </div>

      <form ref={form} onSubmit={sendEmail} className="premium-insurance-form">
        
        {/* SECTION 1: VEHICLE DETAILS */}
        <div className="form-section-card">
          <h3 className="section-title">Vehicle Information</h3>
          <div className="form-grid-3">
            <div className="form-group">
              <label>Car Make</label>
              <input type="text" name="make" placeholder="e.g. Tata" required />
            </div>
            <div className="form-group">
              <label>Car Model</label>
              <input type="text" name="model" placeholder="e.g. Altroz" required />
            </div>
            <div className="form-group">
              <label>Fuel Type</label>
              <input type="text" name="type" placeholder="e.g. Petrol / EV" required />
            </div>
          </div>

          <div className="form-grid-2">
            <div className="form-group">
              <label>Registration City</label>
              <input type="text" name="city" placeholder="e.g. New Delhi" required />
            </div>
            <div className="form-group">
              <label>Date of Purchase</label>
              <input type="date" name="dop" required />
            </div>
          </div>
        </div>

        {/* SECTION 2: CONTACT DETAILS */}
        <div className="form-section-card">
          <h3 className="section-title">Contact Details</h3>
          <div className="form-grid-3">
            <div className="form-group">
              <label>Full Name</label>
              <input type="text" name="fullName" placeholder="Enter your name" required />
            </div>
            <div className="form-group">
              <label>Email Address</label>
              <input type="email" name="email" placeholder="name@domain.com" required />
            </div>
            <div className="form-group">
              <label>Mobile Number</label>
              <input
                type="tel"
                name="mobileNumber"
                placeholder="10-digit number"
                required
                pattern="[0-9]{10}"
                title="Enter a 10-digit mobile number"
              />
            </div>
          </div>

          <div className="form-group full-width-group">
            <label>Subject</label>
            <input type="text" name="subject" placeholder="How can our agents help you?" />
          </div>

          <div className="form-group full-width-group">
            <label>Additional Message</label>
            <textarea name="message" placeholder="Provide any additional details or requirements..." rows="4" />
          </div>
        </div>

        <div className="form-action-wrapper">
          <button type="submit" className="premium-submit-button">
            Request a Callback <span>→</span>
          </button>
          <span className="secure-tag">🔒 Your details are protected and securely processed.</span>
        </div>
      </form>
    </div>
  );
};

export default InsuranceForm;